import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrentUserModel } from "../../models/current-user.model";
import { ApiService } from '../../services/api.service';
import { AccountService } from '../../services/account.service'; 
import { CatalogService } from '../../services/catalog.service'; 
import { MenuService } from '../../services/menu.service';
import { ProcedureService } from '../../services/procedure.service';
import { LoginModel } from '../../models/login.model';
import Swal from 'sweetalert2';
import { isFunction } from 'util';
declare var $: any;

@Component({
	selector: 'ngx-app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
	_loginForm: FormGroup;

	clicked: boolean = false;
	isAuthenticating: boolean = false;
	baseUrl: string = 'account';
	clinics: any = [];
	constructor(
		private api: ApiService,
		public accountService: AccountService,
		private router: Router,
		private menuService: MenuService,
		private catalogService: CatalogService,
		private procedureService: ProcedureService
	) {
		// this._loginForm = new FormGroup({
		// 	Email: new FormControl(null, [Validators.required, Validators.email]),
		// 	Password: new FormControl(null, [Validators.required])
		// });
	}

	get form() {
		return this._loginForm;
	}

	ngOnInit() {
		return;
	}

	Register() {
		this.router.navigate(["/auth/register"]);
	}
	ChangePassword() {
		this.router.navigate(["/auth/change-password"]);
	}
	ForgotPassword() {
		this.router.navigate(["/auth/forgot-password"]);
	}

	private accounts: any = [];

	login() {
		// Swal.fire({
		// 	title: 'Loading...',
		// 	timerProgressBar: true,
		// 	allowOutsideClick: false,
		// 	allowEscapeKey: false,
		// 	didOpen: () => {
		// 		Swal.showLoading()
		// 	},
		// })

		this.clicked = true;
		this.isAuthenticating = true;
		this.accountService.login()
			.then((res: any) => {
				// Normalize response to an array of accounts
				const accounts = Array.isArray(res) ? res : (res && res.data ? res.data : []);
				this.accounts = accounts;
				if (accounts.length > 1) {
					// Store a token temporarily so getClinics() can pass the now-enforced JWT auth
					localStorage.setItem('access_token', accounts[0].token);
					this.catalogService.getClinics().then(() => {
						this.clinics = accounts.map((item: any) => ({
							clinic_no: item.clinic_no,
							clinic_name: (this.catalogService.clinic.find((clinic: any) => clinic.clinic_no == item.clinic_no) || { clinic_name: 'Unknown clinic' }).clinic_name,
							role: item.Role,
		      				role_desc: item.RoleName
						}));
					});
					$('#clinic_modal').modal('show');
				}
				else if (accounts.length == 1) {
					this.proceed(accounts[0]);
				} else {
					throw { message: 'No accounts returned for this user.' };
				}

				this.accountService.login_user = new LoginModel('', '');
			})
			.catch((err: any) => {
				const message = (err && err.error && (err.error.message || err.error.title))
					|| 'The username or password is incorrect';
				Swal.fire({
					title: message,
					text: err && err.error && err.error.detail ? err.error.detail : '',
				})
				this.isAuthenticating = false;
			});

	}

	selectClinic(clinic_no, role){
		$('#clinic_modal').modal('hide');
		this.proceed(this.accounts.find((item: any) => item.clinic_no == clinic_no && item.Role == role));
	}

	proceed(res){
			localStorage.setItem('authenticated', JSON.stringify(true));
			localStorage.setItem('token', res.token);
			localStorage.setItem('currentUser', JSON.stringify(new CurrentUserModel(
				res.Id,
				res.RoleName,
				res.Role,
				res.email,
				res.UserName,
				res.Id,
				res.clinic_no,
				res.tenant_no
			)));

			//assign selected clinic to local storage
			if (localStorage.currentUser) {
				this.catalogService.getClinics().then(() => {
					const currentUser = JSON.parse(localStorage.currentUser);
					if (this.catalogService.clinic.some(t => Number(t.clinic_no) === Number(currentUser.clinic_no))) {
						const item = this.catalogService.clinic.find(t => Number(t.clinic_no) === Number(currentUser.clinic_no));
						localStorage['selected_clinic'] = JSON.stringify(item); 
					} else {
						alert('No clinic found');
					}
				}) 
			}

			this.setUserToken(res.token);
			this.setUserRole(res.RoleName);
			this.setUserRoleNo(res.Role);

			this.loadData(res.clinic_no);
			
			//to get the header menu 
			this.menuService.setRole(res.Role)  
			this.menuService.setNo(124)  
			this.menuService.getHeaderBarMenu().then(() => {})
			this.menuService.getSideBarMenu().then(() => {
				let route = (this.menuService.menu.length == 0) ? '/pages/home-screen/employee-screen' : this.menuService.menu[0].route;
				this.router.navigate([route]).then(() => {
					this.accountService.login_user = new LoginModel('', '');
					this.menuService.setNo(0);
					Swal.close();
				});
			})
  
	}

	checkIcon(role) {
		let toreturn = '';
		if(role == 7){
			toreturn = 'las la-concierge-bell icon-lg';
		} 
		else if(role == 6){
			toreturn = 'las la-user-nurse icon-lg' ;
		}
		else if(role == 5){
			toreturn = 'las la-stethoscope icon-lg' ;
		}
		else if(role == 4){
			toreturn = 'las la-stethoscope icon-lg';
		} 
		else if(role == 3){
			toreturn = 'las la-hospital icon-lg';
		}
		else if(role == 2){
			toreturn = 'las la-user icon-lg';
		}
		else if(role == 1){
			toreturn = 'las la-user-cog icon-lg';
		}

		return toreturn;
	}

	private setUserToken(token: string) {
		localStorage.setItem('access_token', token);
	}

	private setUserRole(role: string) {
		localStorage.setItem('role', JSON.stringify(role));
	}

	private setUserRoleNo(role: number) {
        localStorage.setItem('role_no', JSON.stringify(role));
    }


	loadData(clinic_no: number){
		this.catalogService.oneLoadCatalogs(clinic_no)
	}
}

